import { Avatar, Box, Stack, Tooltip, Typography } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import { useState } from "react";
import GlobalButton from "../../../components/CustomButton";
import appcolors from "../../../constants/Colors";
import { CURRENCY } from "../../../constants/Variables";
import { useSelector } from "react-redux";

const getButtonText = (workerStatus, status) => {
  if (workerStatus === "pending" && status === "pending")
    return t("markAsAccepted");
  if (
    workerStatus === "accepted" &&
    (status === "accepted" || status === "pending" || status === "started")
  )
    return t("markAsCompleted");
  if (workerStatus === "accepted" && status === "completed")
    return t("completed");
  if (workerStatus === "rejected" && status === "pending") return t("rejected");
  return null;
};

const getButtonColor = (workerStatus, status) => {
  if (workerStatus === "rejected" && status === "pending") return "#FF0000"; // Red for rejected
  if (status === "pending" || status === "accepted") return "#08AD36"; // Green for pending/accepted
  if (status === "completed") return "#08AD36"; // Green for completed
  return "#EA580C"; // Default orange
};

const WorkerEvents = ({ event }) => {
  console.log(event, "eventeventeventevent");
  const [open, setOpen] = useState(false);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const toggleTooltip = (value) => {
    setOpen(value);
  };

  const start = moment(event.start);
  const end = moment(event.end);
  const duration = moment.duration(end.diff(start));
  const durationText = `${duration.hours() ? `${duration.hours()}h` : ""}:${
    duration.minutes() ? `${duration.minutes()}m` : ""
  }`;

  console.log(durationText, "durationTextdurationText");

  const commonTextStyle = {
    variant: "body1",
    fontSize: "0.75rem",
    lineHeight: "normal",
    fontFamily: "Roboto",
    lineHeight: 1.4,
  };

  const renderInsideView = () => (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onMouseEnter={() => toggleTooltip(true)}
      onMouseLeave={() => toggleTooltip(false)}
      onTouchStart={() => toggleTooltip(true)}
      className="custom-event"
      spacing={1}
    >
      <Stack direction="row" spacing={2} alignItems={"center"}>
        <Avatar
          src={event?.serviceSubCategoryDetails?.image}
          sx={{ height: 50, width: 50 }}
        />
        <Stack>
          <Stack spacing={1} direction="row" alignItems="center">
            <Typography {...commonTextStyle} fontSize="0.8rem" noWrap>
              {`${start.format("h:mm A")} - ${end.format("h:mm A")}`}
            </Typography>
            <Typography {...commonTextStyle} noWrap>
              {event?.appointmentType}
            </Typography>
          </Stack>
          <Typography {...commonTextStyle} textTransform={"capitalize"}>
            {event?.serviceSubCategoryDetails?.name[currentLanguage]}
          </Typography>
          <Typography
            {...commonTextStyle}
            fontWeight={600}
            textTransform={"capitalize"}
            noWrap
          >
            {t("status")}: {event?.status}
          </Typography>
        </Stack>
      </Stack>

      <GlobalButton
        btnText={getButtonText(event.workerStatus, event.status)}
        variant="contained"
        styleProps={{
          height: 40,
          width: "auto",
          fontSize: "0.875rem",
          backgroundColor: getButtonColor(event.workerStatus, event.status),
          border: "none",
        }}
        hoverProperties={{
          backgroundColor: getButtonColor(event.workerStatus, event.status),
          border: "none",
        }}
      />
    </Stack>
  );

  const renderTooltipView = () => (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={1}
        bgcolor={appcolors.primary}
        color={appcolors.white}
      >
        <Typography variant="body2">{`${start.format("h:mm A")} - ${end.format(
          "h:mm A"
        )}`}</Typography>
        <Typography variant="body2">{event?.appointmentType}</Typography>
      </Stack>
      <Stack p={1.5} direction="row" alignItems="center" gap={1}>
        <Avatar
          src={event?.userId?.profileImg}
          sx={{ height: 50, width: 50 }}
        />
        <Box>
          <Typography variant="body2">{`${event?.userId?.firstname} ${event?.userId?.lastname}`}</Typography>
          {/* <Typography
            variant="body2"
            fontSize="0.75rem"
            color={appcolors.charcolGrey}
          >
            {event?.userId?.email}
          </Typography> */}
        </Box>
      </Stack>
      <Stack
        p={1}
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Typography {...commonTextStyle} textTransform={"capitalize"}>
            {event?.serviceSubCategoryDetails?.name[currentLanguage]}
          </Typography>
          <Typography {...commonTextStyle}>
            <strong>{t("status")}:</strong> {event.status}
          </Typography>
          <Typography {...commonTextStyle} color={appcolors.charcolGrey}>
            {t("duration")}: {durationText}
          </Typography>
        </Box>
        <Typography {...commonTextStyle} fontSize="0.89rem" fontWeight={400}>
          {CURRENCY} {event?.totalCost || 0}
        </Typography>
      </Stack>
    </Box>
  );

  return (
    <Tooltip
      open={open}
      title={renderTooltipView()}
      onClose={() => toggleTooltip(false)}
      onOpen={() => toggleTooltip(true)}
      disableHoverListener
      disableTouchListener
      PopperProps={{
        sx: {
          "& .MuiTooltip-tooltip": {
            padding: "0px",
            color: "#000000",
            backgroundColor: "#ffffff",
            border: "1px solid #ddd",
            boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
            borderRadius: "6px",
            overflow: "hidden",
            minWidth: "300px",
            maxWidth: "400px",
          },
        },
      }}
    >
      {renderInsideView()}
    </Tooltip>
  );
};

export default WorkerEvents;
